import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class MixturaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    AgregarMixtura(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: mixturaInputType) {
            mixtura {
              agregar(entidad: $entidad) {
                respuesta {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.mixtura.agregar;
            callback({ mensajes, respuesta });
        });
    }
    EditarMixtura(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: mixturaInputType) {
            mixtura {
              modificar(entidad: $entidad) {
                respuesta {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.mixtura.modificar;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: mixturaInputType) {
            mixtura {
              obtenerSegunFiltro(filtro: { exacto: $entidad }) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    activado
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.mixtura.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
          query {
            mixtura {
              obtenerTodos {
                respuesta {
                  registros {
                    codigo
                    activado
                    nombre
                  }
                }
              }
            }
          }
        `,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.mixtura.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
}
MixturaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MixturaService_Factory() { return new MixturaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: MixturaService, providedIn: "root" });
